// extracted by mini-css-extract-plugin
export var bodySections = "_61-8";
export var gray = "_61-7";
export var green = "_61-4";
export var iconContainer = "_61-9";
export var iconWidgetContainer = "_61-1";
export var phoneIcon = "_61-2";
export var red = "_61-5";
export var statusDot = "_61-3";
export var widgetContainer = "_61-0";
export var yellow = "_61-6";